const SIZE_GUIDE_HASH = '#guia-de-tamanos';
const ALIGNMENT_DELAYS = [0, 250, 750, 1500, 2750, 4500, 6500];
let alignmentTimers = [];
let alignmentActive = false;

function cancelSizeGuideAlignment() {
  alignmentTimers.forEach((timer) => window.clearTimeout(timer));
  alignmentTimers = [];
  alignmentActive = false;
}

function alignSizeGuide() {
  if (!alignmentActive || window.location.hash !== SIZE_GUIDE_HASH) return;

  const target = document.getElementById('guia-de-tamanos');
  if (!target) return;

  target.scrollIntoView({ block: 'start', behavior: 'auto' });
}

function scheduleSizeGuideAlignment() {
  cancelSizeGuideAlignment();
  if (window.location.hash !== SIZE_GUIDE_HASH) return;

  alignmentActive = true;
  alignmentTimers = ALIGNMENT_DELAYS.map((delay) => window.setTimeout(alignSizeGuide, delay));
}

function scheduleFromGuideLink(event) {
  if (!(event.target instanceof Element)) return;

  const link = event.target.closest(`a[href*="${SIZE_GUIDE_HASH}"]`);
  if (!link) return;

  window.setTimeout(scheduleSizeGuideAlignment, 0);
}

['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((eventName) => {
  window.addEventListener(eventName, cancelSizeGuideAlignment, { passive: true });
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleSizeGuideAlignment, { once: true });
} else {
  scheduleSizeGuideAlignment();
}

window.addEventListener('load', scheduleSizeGuideAlignment, { once: true });
window.addEventListener('pageshow', scheduleSizeGuideAlignment, { once: true });
window.addEventListener('hashchange', scheduleSizeGuideAlignment);
document.addEventListener('click', scheduleFromGuideLink);
